module.exports = __webpack_public_path__ + "static/media/descarga.9e73e9cd.svg";